var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showOverlay)?_c('div',{staticClass:"data-overlay"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }